/**
 * will append base url to each request if set in the global mds object
 * @param axiosInstance
 */
const initAxiosBaseUrlInterceptor = (axiosInstance) => {
  const { baseUrl } = window.mds || {};
  if (baseUrl) {
    axiosInstance.interceptors.request.use((config) => {
      const sep = config.url.startsWith('/') ? '' : '/';
      const url = `${baseUrl}${sep}${config.url}`;
      return { ...config, url };
    });
  }
};

export default initAxiosBaseUrlInterceptor;
